import React, { useEffect, useState, useMemo } from "react"
import { connect } from "react-redux"
import * as JoinActions from "../../store/actions"
import { useSelector, useDispatch } from "react-redux"
import { Button, Modal, ModalHeader, ModalBody, ModalFooter } from "reactstrap"
import TableContainer from "components/Common/TableContainer"
import { Pdate, Ddate, Name } from "./AccCol"
import { toast } from "react-toastify"

const joinRequest = () => {
  const { serviceProviderRequests, error } = useSelector(
    state => state.serviceProviders
  )
  const dispatch = useDispatch()
  const [selectedProviderData, setSelectedProviderData] = useState(null)
  const [modal1, setModal1] = useState(false)
  const [isModalOpen, setIsModalOpen] = useState(false)
  const [discription, setDiscription] = useState(null)

  useEffect(() => {
    dispatch(JoinActions.fetchServiceProviderRequestsRequest())
  }, [])
  if (error) {
    toast.error('مزود الخدمة بالبريد الإلكتروني المطلوب موجود بالفعل');
    dispatch(JoinActions.clearError())
  }

  const toggleModal = () => {
    setIsModalOpen(!isModalOpen)
  }

  const moreDetails = providerData => {
    setSelectedProviderData(providerData)
    toggleModal()
  }

  const toggleViewModal = providerData => {
    setSelectedProviderData(providerData)
    setModal1(!modal1)
  }

  const approved = data => {
    dispatch(JoinActions.approveServiceProviderRequest(data))
  }

  const rejected = data => {
    const ids = {
      collectionId: data.collectionId,
      id: data.id
    }
    dispatch(JoinActions.rejectServiceProviderRequest(ids))
  }

  const columns = useMemo(
    () => [
      {
        accessor: "action",
        disableFilters: true,
        Cell: ({ row }) => (
          <Button onClick={() => approved(row.original)}>قبول</Button>
        ),
      },
      {
        accessor: "reject",
        disableFilters: true,
        Cell: ({ row }) => (
          <Button className="btn-danger" onClick={() => rejected(row.original)}>
            رفض
          </Button>
        ),
      },

      {
        Header: "اسم العميل",
        accessor: "full_name",
        disableFilters: true,
        filterable: true,
        Cell: cellProps => <Name {...cellProps} />,
      },
      {
        accessor: "email",
        disableFilters: false,
        filterable: true,
        Cell: cellProps => <Pdate {...cellProps} />,
      },
      {
        Header: "الهاتف",
        accessor: "mobile",
        disableFilters: true,
        filterable: true,
        Cell: cellProps => <Ddate {...cellProps} />,
      },

      {
        Header: "التفاصيل",
        accessor: "details",
        disableFilters: true,
        Cell: ({ row }) => (
          <Button color="info" size="sm" onClick={() => moreDetails(row.original)}>
            عرض التفاصيل
          </Button>
        ),
      },
    ],
    []
  )

  return (
    <div>

      <TableContainer
        columns={columns}
        data={serviceProviderRequests || []}
        isGlobalFilter={false}
        customPageSize={5}
        customPageSizeOptions={true}
      />
      <ProviderDetailsModal
        isOpen={isModalOpen}
        toggleModal={toggleModal}
        providerData={selectedProviderData}
        onApprove={approved}
        onReject={rejected}
      />
    </div>
  )
}
const mapStateToProps = state => ({
  ProvidersList: state.serviceProviders,
})

const ProviderDetailsModal = ({ isOpen, toggleModal, providerData, onApprove, onReject }) => {
  if (!providerData) return null;

  const handleApprove = () => {
    onApprove(providerData);
    toggleModal();
  };

  const handleReject = () => {
    onReject(providerData);
    toggleModal();
  };

  return (
    <Modal isOpen={isOpen} toggle={toggleModal} size="lg">
      <ModalHeader toggle={toggleModal}>
        <i className="mdi mdi-account-check me-2"></i>
        تفاصيل طلب الانضمام
      </ModalHeader>
      <ModalBody>
        <div className="table-responsive">
          <table className="table table-borderless align-middle mb-0">
            <tbody>
              {/* Personal Information */}
              <tr className="bg-light">
                <td colSpan="2" className="py-2">
                  <strong className="text-primary">
                    <i className="mdi mdi-account-circle me-2"></i>
                    المعلومات الشخصية
                  </strong>
                </td>
              </tr>
              <tr>
                <td style={{ width: "40%" }} className="text-muted">الاسم الثلاثي</td>
                <td className="fw-medium">{providerData.full_name || "غير متوفر"}</td>
              </tr>
              <tr>
                <td className="text-muted">البريد الإلكتروني</td>
                <td className="fw-medium">{providerData.email || "غير متوفر"}</td>
              </tr>
              <tr>
                <td className="text-muted">رقم الهاتف</td>
                <td className="fw-medium" style={{ direction: "ltr", textAlign: "right" }}>
                  {providerData.mobile || "غير متوفر"}
                </td>
              </tr>

              {/* Salon Information */}
              <tr className="bg-light">
                <td colSpan="2" className="py-2 pt-3">
                  <strong className="text-primary">
                    <i className="mdi mdi-store me-2"></i>
                    معلومات الصالون
                  </strong>
                </td>
              </tr>
              <tr>
                <td className="text-muted">اسم الصالون</td>
                <td className="fw-medium">{providerData.salon_name || "غير متوفر"}</td>
              </tr>
              {providerData.description && (
                <tr>
                  <td className="text-muted">الوصف</td>
                  <td className="fw-medium">{providerData.description}</td>
                </tr>
              )}

              {/* Tax & Registration */}
              <tr className="bg-light">
                <td colSpan="2" className="py-2 pt-3">
                  <strong className="text-primary">
                    <i className="mdi mdi-file-document me-2"></i>
                    معلومات التسجيل التجاري
                  </strong>
                </td>
              </tr>
              {providerData.commercial_register ? (
                <tr>
                  <td className="text-muted">رقم السجل التجاري</td>
                  <td className="fw-medium" style={{ direction: "ltr", textAlign: "right" }}>
                    {providerData.commercial_register}
                  </td>
                </tr>
              ) : (
                <tr>
                  <td className="text-muted">رقم السجل التجاري</td>
                  <td className="text-danger fst-italic">غير متوفر</td>
                </tr>
              )}
              {providerData.tax_number ? (
                <tr>
                  <td className="text-muted">الرقم الضريبي</td>
                  <td className="fw-medium" style={{ direction: "ltr", textAlign: "right" }}>
                    {providerData.tax_number}
                  </td>
                </tr>
              ) : (
                <tr>
                  <td className="text-muted">الرقم الضريبي</td>
                  <td className="text-danger fst-italic">غير متوفر</td>
                </tr>
              )}

              {/* Request Information */}
              {providerData.createdAt && (
                <>
                  <tr className="bg-light">
                    <td colSpan="2" className="py-2 pt-3">
                      <strong className="text-primary">
                        <i className="mdi mdi-clock-outline me-2"></i>
                        معلومات الطلب
                      </strong>
                    </td>
                  </tr>
                  <tr>
                    <td className="text-muted">تاريخ تقديم الطلب</td>
                    <td className="fw-medium">
                      {new Date(providerData.createdAt).toLocaleDateString('ar-SA', {
                        year: 'numeric',
                        month: 'long',
                        day: 'numeric'
                      })}
                    </td>
                  </tr>
                </>
              )}
            </tbody>
          </table>
        </div>
      </ModalBody>
      <ModalFooter>
        <Button color="secondary" onClick={toggleModal}>
          <i className="mdi mdi-close me-1"></i>
          إغلاق
        </Button>
        <Button color="danger" onClick={handleReject}>
          <i className="mdi mdi-close-circle me-1"></i>
          رفض الطلب
        </Button>
        <Button color="success" onClick={handleApprove}>
          <i className="mdi mdi-check-circle me-1"></i>
          قبول الطلب
        </Button>
      </ModalFooter>
    </Modal>
  )
}

export default connect(mapStateToProps, JoinActions)(joinRequest)
